import React from "react"
import { Label, CheckboxWrapper, FieldError } from "../styles"
import { CheckElement } from "../../../styles/form-elements"
import CheckIcon from "../../../images/check.inline.svg"
import { Small } from "../../../styles"
import { Controller } from "react-hook-form"

const Checkbox = ({
  control,
  defaultValue = false,
  label,
  name,
  register,
  error,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        return (
          <CheckboxWrapper>
            <input
              type="checkbox"
              css={`
                clip: rect(0 0 0 0);
                clip-path: inset(50%);
                height: 1px;
                overflow: hidden;
                position: absolute;
                white-space: nowrap;
                width: 1px;
              `}
              onChange={(e) => {
                // onChange's arg will send value into hook form
                onChange(e.target.checked)
              }}
              value={value}
              // {...register(name)}
            />
            <CheckElement
              checked={!!value}
              css={`
                margin-top: 0.25em;
              `}
            >
              <CheckIcon />
            </CheckElement>
            <Label as="p">
              <Small>{label}</Small>
            </Label>
            {error && <FieldError>{error}</FieldError>}
          </CheckboxWrapper>
        )
      }}
    />
  )
}

export default Checkbox
